import { render, staticRenderFns } from "./DicInsurance.vue?vue&type=template&id=5b49490a&scoped=true"
import script from "./DicInsurance.vue?vue&type=script&lang=js"
export * from "./DicInsurance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b49490a",
  null
  
)

export default component.exports